module.exports = __webpack_public_path__ + "assets/img/tablet.d06bd91f.jpg";